document.addEventListener('DOMContentLoaded', function () {
  initDisclosures();
  initManageCookiesLink();
  initQuantitySteppers();
  initGalleryThumbs();
  initPillSync();
  initProductInfoForms();
  initProductRecommendations();
  initCollectionSort();
  initSignupModals();
});

/**
 * Only one <details> disclosure (mobile menu, search) open at a time,
 * and close it when a click lands outside it.
 */
function initDisclosures() {
  var detailsEls = document.querySelectorAll('header details');

  document.addEventListener('click', function (event) {
    detailsEls.forEach(function (details) {
      if (details.open && !details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  detailsEls.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        detailsEls.forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
      }
    });
  });

  document.querySelectorAll('.mobile-nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      var parentDetails = link.closest('details');
      if (parentDetails) parentDetails.removeAttribute('open');
    });
  });
}

/**
 * Manage Cookies footer link: hook left in place for wiring up to
 * Shopify's Customer Privacy API in a later iteration.
 */
function initManageCookiesLink() {
  var manageCookiesLink = document.getElementById('manage-cookies');
  if (!manageCookiesLink) return;
  manageCookiesLink.addEventListener('click', function (event) {
    event.preventDefault();
    // TODO: reopen native cookie-preferences banner once wired up.
  });
}

/**
 * +/- quantity steppers, used on the product page and cart. Dispatches a
 * change event so anything listening for manual edits (e.g. cart auto-save)
 * still fires.
 */
function initQuantitySteppers() {
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input[type="number"]');
    var decrease = stepper.querySelector('.qty-decrease');
    var increase = stepper.querySelector('.qty-increase');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;

    if (decrease) {
      decrease.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || min;
        input.value = Math.max(min, val - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (increase) {
      increase.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || min;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });
}

/**
 * Product gallery: clicking a thumbnail swaps the main image. Prev/next
 * arrow buttons (added 2026-09-17, per explicit request) step through the
 * same thumbnail order, wrapping at either end.
 */
function initGalleryThumbs() {
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.product-gallery__main img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
    var prevBtn = gallery.querySelector('.product-gallery__arrow--prev');
    var nextBtn = gallery.querySelector('.product-gallery__arrow--next');
    if (!main || !thumbs.length) return;

    function showThumb(thumb) {
      main.src = thumb.dataset.imageUrl;
      main.srcset = '';
      main.removeAttribute('sizes');
      if (thumb.dataset.imageAlt) main.alt = thumb.dataset.imageAlt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showThumb(thumb); });
    });

    // Reads the current position from aria-current rather than a
    // separately tracked index, so an arrow click stays correct even if
    // the variant picker (see initProductInfoForms) swapped the main
    // image directly without going through showThumb — worst case it
    // starts from whichever thumb was last marked current, rather than
    // silently drifting out of sync with what's actually on screen.
    function step(direction) {
      var currentIndex = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      if (currentIndex === -1) currentIndex = 0;
      var nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
      showThumb(thumbs[nextIndex]);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
  });
}

/**
 * Adds an `is-selected` class to the chosen size/option pill so styling
 * doesn't depend solely on the :has() selector (older browser fallback +
 * a hook other scripts can rely on).
 */
function initPillSync() {
  document.querySelectorAll('.pill-list input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.closest('.pill-list');
      if (!group) return;
      group.querySelectorAll('.pill-option').forEach(function (label) {
        label.classList.remove('is-selected');
      });
      var ownLabel = input.closest('.pill-option');
      if (ownLabel) ownLabel.classList.add('is-selected');
    });
  });
}

/**
 * Product page variant picker: swaps price, availability, stock badge, and
 * main image to match the selected color/size combination. Reads its data
 * from the per-variant JSON blob main-product.liquid renders server-side
 * (already money-formatted, so this never reimplements currency formatting).
 *
 * Fixed 2026-09-17 — two related bugs, same root cause: findVariant()
 * only ever matched an EXACT combination of every option's current
 * selection, and updateUI() silently no-op'd (`if (!variant) return`)
 * whenever that lookup failed. On a two-axis Style + Size product, that
 * meant changing Style to a value that doesn't pair with the currently
 * selected Size (e.g. Style -> "Dad" while Size is still "1M", which has
 * no Dad variant) matched nothing — so the image, price, variant id, and
 * Add to Bag button all silently stayed on the stale prior selection, and
 * the Size pill kept showing an option that no longer applied. Generic
 * fix, not hardcoded to Style/Size: findFallbackVariant() looks at
 * whichever option index the shopper just changed, finds a real variant
 * that keeps that new value (see its own comment for how it scores
 * candidates against the other currently-selected axes), and
 * syncOptionInputs() reflects that choice back into the other option
 * groups' own radio inputs before the normal updateUI() runs — so this
 * applies to any product using this variant pattern regardless of how
 * many options it has, and to picking any option first.
 */
function initProductInfoForms() {
  document.querySelectorAll('.product-info[data-section-id]').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var dataEl = document.getElementById('ProductVariants-' + sectionId);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    // Array form built once and reused by every lookup below, rather than
    // re-deriving it from the variants object on every option change.
    var variantList = Object.keys(variants).map(function (id) {
      return Object.assign({ id: id }, variants[id]);
    });

    var variantIdInput = root.querySelector('[data-product-variant-id]');
    var priceEls = root.querySelectorAll('[data-product-price]');
    var stockEl = root.querySelector('[data-product-stock-badge]');
    var submitBtn = root.querySelector('[data-product-submit]');
    var galleryMain = document.querySelector('[data-product-gallery-main="' + sectionId + '"]');
    var optionInputs = root.querySelectorAll('input[data-option-index]');
    if (!optionInputs.length) return;

    function selectedOptions() {
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.checked) groups[input.dataset.optionIndex] = input.value;
      });
      var opts = [];
      var i = 0;
      while (Object.prototype.hasOwnProperty.call(groups, String(i))) {
        opts.push(groups[String(i)]);
        i++;
      }
      return opts;
    }

    function findVariant(selected) {
      for (var i = 0; i < variantList.length; i++) {
        var v = variantList[i];
        if (
          v.options.length === selected.length &&
          v.options.every(function (val, idx) { return val === selected[idx]; })
        ) {
          return v;
        }
      }
      return null;
    }

    // The other axes' current selections may not exist for the option
    // value that was just changed. Finds a replacement variant that keeps
    // the just-changed option's new value.
    //
    // Fixed 2026-09-18 — on a 2-option (Style + Size) product this only
    // ever had one "other axis" to lose, so picking the first available
    // variant with the new value could only ever cascade into a Size
    // reset, matching spec. Once a third axis (Color) was added to some
    // products, that same first-match approach could ALSO silently swap
    // Color out from under the shopper — e.g. changing Style away from a
    // combination that only exists for a different Color jumped them to
    // that other Color entirely, not just a different Size. currentSelected
    // (the just-updated, pre-lookup selection — see the change listener
    // below) lets candidates be scored by how many of the OTHER axes they
    // still match, so a candidate that keeps Color (or even Size) wins
    // over one that doesn't; only when nothing matches any other axis does
    // this fall back to the old "first available" behavior. For genuine
    // 2-option products every candidate scores 0 on the one other axis
    // (if it could score higher, findVariant would already have matched),
    // so behavior there is unchanged.
    function findFallbackVariant(changedIndex, changedValue, currentSelected) {
      var candidates = variantList.filter(function (v) {
        return v.options[changedIndex] === changedValue;
      });
      if (!candidates.length) return null;

      function matchScore(v) {
        var score = 0;
        for (var i = 0; i < v.options.length; i++) {
          if (i === changedIndex) continue;
          if (currentSelected[i] !== undefined && v.options[i] === currentSelected[i]) score++;
        }
        return score;
      }

      var best = null;
      var bestScore = -1;
      var bestAvailable = false;
      candidates.forEach(function (v) {
        var score = matchScore(v);
        var better = score > bestScore || (score === bestScore && !bestAvailable && v.available);
        if (better) {
          best = v;
          bestScore = score;
          bestAvailable = v.available;
        }
      });
      return best;
    }

    // Reflects a fallback variant's full option set back into the other
    // option groups' own radio inputs and their visible ": value" label
    // and selected-pill styling — so e.g. auto-resetting Size after a
    // Style change actually shows the new Size, not just the hidden
    // variant id. Sets `.checked` and updates the same visual hooks
    // initPillSync() maintains directly, rather than dispatching a
    // `change` event, since that would re-enter this same option-change
    // handler for an already-settled selection.
    function syncOptionInputs(variant) {
      variant.options.forEach(function (value, idx) {
        var input = root.querySelector('input[data-option-index="' + idx + '"][value="' + CSS.escape(value) + '"]');
        if (!input) return;

        var group = input.closest('.pill-list, .swatch-list');
        var optionRoot = input.closest('.product-option');
        var valueEl = optionRoot && optionRoot.querySelector('.product-option__value');
        if (valueEl) valueEl.textContent = ': ' + value;

        if (input.checked) return;
        input.checked = true;
        if (group) {
          group.querySelectorAll('.pill-option, .swatch').forEach(function (label) {
            label.classList.remove('is-selected');
          });
          var ownLabel = input.closest('.pill-option, .swatch');
          if (ownLabel) ownLabel.classList.add('is-selected');
        }
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      priceEls.forEach(function (priceEl) {
        if (variant.on_sale) {
          priceEl.innerHTML =
            '<span class="product-info__price--sale">' + variant.price + '</span>' +
            '<span class="product-info__price--compare">' + variant.compare_at_price + '</span>';
        } else {
          priceEl.textContent = variant.price;
        }
      });

      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        var label = submitBtn.querySelector('span');
        if (label) label.textContent = variant.available ? 'Add to Bag' : 'Sold out';
      }

      if (stockEl) {
        var qty = variant.inventory_quantity;
        var threshold = parseInt(stockEl.dataset.threshold, 10) || 10;
        if (variant.inventory_management === 'shopify' && qty > 0 && qty <= threshold) {
          stockEl.textContent = 'Almost gone — only ' + qty + ' left';
          stockEl.style.display = 'inline-flex';
        } else {
          stockEl.style.display = 'none';
        }
      }

      // Falls back to keeping the current image when this Style has no
      // dedicated image uploaded (variant.featured_image blank) — never
      // clears the gallery to a broken or blank state.
      if (galleryMain && variant.featured_image) {
        var img = galleryMain.querySelector('img');
        if (img) {
          img.src = variant.featured_image;
          img.srcset = '';
          img.removeAttribute('sizes');
          if (variant.featured_image_alt) img.alt = variant.featured_image_alt;
        }
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var changedIndex = parseInt(input.dataset.optionIndex, 10);
        // The browser has already applied this radio's checked state by
        // the time 'change' fires, so this already reflects the new value
        // at changedIndex alongside every other option's prior selection —
        // exactly the reference findFallbackVariant needs to score against.
        var currentSelected = selectedOptions();
        var variant = findVariant(currentSelected);
        if (!variant) {
          variant = findFallbackVariant(changedIndex, input.value, currentSelected);
          if (variant) syncOptionInputs(variant);
        }
        updateUI(variant);
      });
    });
  });
}

/**
 * Fetches the "You'll Also Love" section through Shopify's Product
 * Recommendations + Section Rendering API and swaps it in — the
 * `recommendations` Liquid object is only populated when a section is
 * rendered through that endpoint, so the static page load always starts
 * with this placeholder empty.
 */
function initProductRecommendations() {
  document.querySelectorAll('[data-product-recommendations]').forEach(function (mount) {
    var url = mount.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (text) {
        var temp = document.createElement('div');
        temp.innerHTML = text;
        var populated = temp.querySelector('[data-product-recommendations]');
        if (populated && populated.innerHTML.trim().length) {
          mount.innerHTML = populated.innerHTML;
        }
      })
      .catch(function () {
        // Leave the section empty rather than showing a broken state.
      });
  });
}

/**
 * Collection sort-by dropdown: navigates with the sort_by param on change.
 */
function initCollectionSort() {
  var select = document.querySelector('[data-collection-sort]');
  if (!select) return;
  select.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });
}

/**
 * Post-signup discount popup. The email form itself is a normal (non-AJAX)
 * POST — reliability over polish — so this just checks, on page load,
 * whether the reload was a successful submission (data-show-on-load) and
 * reveals the already-rendered modal if so. Also wires close (backdrop,
 * close button, Escape) and a copy-to-clipboard button for the code.
 */
function initSignupModals() {
  document.querySelectorAll('.signup-modal').forEach(function (modal) {
    function openModal() {
      modal.hidden = false;
      var closeBtn = modal.querySelector('.signup-modal__close');
      if (closeBtn) closeBtn.focus();
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    if (modal.dataset.showOnLoad === 'true') {
      openModal();
    }

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    var copyBtn = modal.querySelector('[data-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.dataset.copyCode;
        var label = copyBtn.querySelector('span');
        var reset = function () {
          if (label) label.textContent = 'Copy';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            if (label) label.textContent = 'Copied!';
            setTimeout(reset, 2000);
          }).catch(function () {
            // Clipboard permission denied or unavailable — the code is
            // still visible in the panel for the shopper to select by hand.
          });
        }
      });
    }
  });
}
